export type AccrualCheck = 'In Line' | 'Minor' | 'Investigate'

const absolute = (value: bigint) => (value < 0n ? -value : value)

/** Compare the original decimal amounts, independently of whole-number display rounding. */
export const getAccrualCheck = (
  amount: string | null | undefined,
  average: string | null | undefined,
): AccrualCheck | null => {
  if (amount == null || average == null) return null
  const pattern = /^[+-]?\d+(?:\.\d+)?$/
  if (!pattern.test(amount) || !pattern.test(average)) return null
  const places = Math.max(amount.split('.')[1]?.length ?? 0, average.split('.')[1]?.length ?? 0)
  const scaled = (value: string) => {
    const [integer, fraction = ''] = value.replace(/^[+-]/, '').split('.')
    const result = BigInt(integer + fraction.padEnd(places, '0'))
    return value.startsWith('-') ? -result : result
  }
  const actual = scaled(amount)
  const baseline = scaled(average)
  const difference = absolute(actual - baseline)
  if (baseline === 0n) return difference === 0n ? 'In Line' : 'Investigate'
  const percentageNumerator = difference * 100n
  if (percentageNumerator < absolute(baseline)) return 'In Line'
  if (percentageNumerator <= absolute(baseline) * 5n) return 'Minor'
  return 'Investigate'
}
